<template>
  <div class="app-container asset-po-page">
    <!-- 搜索条件 -->
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="PO单号">
                <el-input v-model="searchForm.opTicketid" placeholder="请输入PO单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="DCOPS单号">
                <el-input
                  v-model="searchForm.dcops_ticket_id"
                  placeholder="请输入DCOPS单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="机房名称">
                <el-input v-model="searchForm.idc_name" placeholder="请输入机房名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="任务名称">
                <el-input v-model="searchForm.task_name" placeholder="请输入任务名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="处理人">
                <el-input v-model="searchForm.current_user" placeholder="请输入处理人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="openColumnsDialog">列设置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      class="po-detail-table"
    >
      <el-table-column
        v-for="column in visibleColumns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth || 120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="column.prop === 'dispatch_time' || column.prop === 'expire_time'">
            {{
              scope.row[column.prop]
                ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                : '-'
            }}
          </span>
          <span v-else>{{ scope.row[column.prop] || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 列设置对话框 -->
    <el-dialog title="列设置" :visible.sync="showColumnsDialog" width="400px" append-to-body>
      <el-checkbox-group v-model="selectedColumns">
        <div v-for="column in columns" :key="column.prop" style="margin-bottom: 10px">
          <el-checkbox :label="column.prop">{{ column.label }}</el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showColumnsDialog = false">取消</el-button>
        <el-button @click="selectAllColumns">全选</el-button>
        <el-button @click="restoreDefaultColumns">恢复默认</el-button>
        <el-button type="primary" @click="saveColumnsDialog">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { assetPoServiceAppendix } from '@/api/appManage';

export default {
  name: 'PoServiceDetail',
  props: {
    opTicketid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchForm: {
        opTicketid: this.opTicketid || '',
        dcops_ticket_id: '',
        ticket_instance_name: '',
        task_name: '',
        idc_name: '',
        current_user: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showColumnsDialog: false,
      selectedColumns: [
        'opTicketid',
        'dcops_ticket_id',
        'ticket_instance_name',
        'task_name',
        'task_desc',
        'dispatch_time',
        'expire_time',
        'idc_name',
        'current_user',
        'current_phone',
      ],
      defaultSelectedColumns: [
        'opTicketid',
        'dcops_ticket_id',
        'ticket_instance_name',
        'task_name',
        'task_desc',
        'dispatch_time',
        'expire_time',
        'idc_name',
        'current_user',
        'current_phone',
      ],
      columns: [
        { prop: 'opTicketid', label: '鸿运侧PO工单号', width: 150 },
        { prop: 'dcops_ticket_id', label: '工作工单号', width: 150 },
        { prop: 'ticket_instance_name', label: '流程标识', width: 150 },
        { prop: 'task_name', label: '任务名称', width: 150 },
        { prop: 'task_desc', label: '工单标题', width: 200 },
        { prop: 'dispatch_time', label: '派单时间', width: 160 },
        { prop: 'expire_time', label: 'SLA截止时间', width: 160 },
        { prop: 'by_the_piece_num', label: '按件数量', width: 100 },
        { prop: 'by_quantity_num', label: '按量数量', width: 100 },
        { prop: 'idc_name', label: '机房名称', width: 150 },
        { prop: 'current_phone', label: '处理人手机', width: 120 },
        { prop: 'current_user', label: '处理人名称', width: 120 },
      ],
    };
  },
  computed: {
    visibleColumns() {
      return this.columns.filter((column) => this.selectedColumns.includes(column.prop));
    },
  },
  watch: {
    opTicketid: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.searchForm.opTicketid = newVal;
          this.fetchData();
        }
      },
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          skip: this.currentPage,
          limit: this.pageSize,
          opTicketid: this.searchForm.opTicketid,
          dcops_ticket_id: this.searchForm.dcops_ticket_id,
          ticket_instance_name: this.searchForm.ticket_instance_name,
          task_name: this.searchForm.task_name,
          idc_name: this.searchForm.idc_name,
          current_user: this.searchForm.current_user,
        };
        
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });
        
        const response = await assetPoServiceAppendix(params);
        if (response && response.data.code === 200) {
          this.tableData = response.data.data.list || [];
          this.total = response.data.data.total || 0;
        } else {
          this.$message.error(response.message || '获取数据失败');
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败，请稍后重试');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset() {
      this.searchForm = {
        opTicketid: this.opTicketid || '',
        dcops_ticket_id: '',
        ticket_instance_name: '',
        task_name: '',
        idc_name: '',
        current_user: '',
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((col) => col.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}
::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}
/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
</style>